import { EVENTS_MAPPING } from '../constants';
import localStorage from './localStorage';

class Tracker {

    initialize(context) {

        this.context = context;
    }

    trackHowFiverrWorksVideo(payload) {
        MixpanelWrapper.trackEvent(
            EVENTS_MAPPING.CLICK.TARGETS.HOW_FIVERR_WORKS_VIDEO,
            payload
        );
    }

    view(categorySlug, title, loggedIn) {

        MixpanelWrapper.trackEvent(
            EVENTS_MAPPING.PAGE_VIEWED.mixpanel,
            {
                'Page Name': 'Category',
                'Category Name': title
            }
        );
        !loggedIn && localStorage.storePageView(categorySlug);
    }
}

export default new Tracker();
